import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'Services/APIService';
// import { getUsers, getRoles } from '../../Services/UserService';

// Service functions
export const getUsers = async () => {
  try {
    const response = await axiosInstance.get('users');
    return response.data; // Return the fetched data
  } catch (error) {
    throw new Error('Failed to fetch users');
  }
};

export const getRoles = async () => {
  try {
    const response = await axiosInstance.get('roles/get');
    return response.data; // Return the fetched data
  } catch (error) {
    throw new Error('Failed to fetch roles');
  }
};

// Define the shape of your state
interface UserManagementState {
  users: any[]; // Replace `any` with the actual type of your users
  userRoles: any[]; // Replace `any` with the actual type of your roles
  loading: boolean;
  error: string | null; // Allow `error` to be a string or null
}

// Initial state
const initialState: UserManagementState = {
  users: [],
  userRoles: [],
  loading: false,
  error: null
};

// Async thunks
export const fetchUsers = createAsyncThunk('users/fetch', async (_, thunkAPI) => {
  try {
    const users = await getUsers();
    return users; // Return the fetched data
  } catch (error) {
    // Safely handle the `unknown` error
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch users';
    return thunkAPI.rejectWithValue(errorMessage); // Handle errors
  }
});

export const fetchRoles = createAsyncThunk('users/fetchRoles', async (_, thunkAPI) => {
  try {
    const roles = await getRoles();
    return roles; // Return the fetched data
  } catch (error) {
    // Safely handle the `unknown` error
    const errorMessage = error instanceof Error ? error.message : 'Failed to fetch roles';
    return thunkAPI.rejectWithValue(errorMessage); // Handle errors
  }
});

// Slice definition
export const usermanagement = createSlice({
  name: 'usermanagement',
  initialState,
  reducers: {
    // You can add standard reducers here if needed
  },
  extraReducers: (builder) => {
    // Fetch Users
    builder.addCase(fetchUsers.pending, (state) => {
      state.loading = true;
      state.error = null; // Reset error state
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      state.users = action.payload; // Set users data
      state.loading = false;
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string; // Set error message
    });

    // Fetch Roles
    builder.addCase(fetchRoles.pending, (state) => {
      state.loading = true;
      state.error = null; // Reset error state
    });
    builder.addCase(fetchRoles.fulfilled, (state, action) => {
      state.userRoles = action.payload; // Set roles data
      state.loading = false;
    });
    builder.addCase(fetchRoles.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string; // Set error message
    });
  }
});

export default usermanagement.reducer;
